import { escapeHTML } from '@disy/lib/escape-html';
import { mark } from '@disy/lib/mark';

export function escapeAndMarkHTML(value: string | undefined, leadingP = true) {
  return mark(escapeHTML(value), leadingP);
}
